import { Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { GovAuthorEvaluationOverview } from '@/module/GovEvaluation/GovAuthorEvaluationOverview';
import { getGovEvaluationOptions } from '@/module/GovEvaluation/model/GovEvaluationQuery';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/gov-evaluation/_layout/$evaluationId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
  loader: async ({ params: { evaluationId }, context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getGovEvaluationOptions(evaluationId));
  },
});

function RouteComponent() {
  const { evaluationId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getGovEvaluationOptions(evaluationId));
  const userId = Route.useSearch().userId;
  const { currentRole } = useCurrentUser();

  return (
    <Stack>
      {userId != null && (
        <GovAuthorEvaluationOverview
          evaluation={evaluation}
          userId={userId}
          canVerifyEvaluation={currentRole != 'AUTHOR'}
          canStartEvaluation={currentRole == 'AUTHOR'}
          currentRole={currentRole}
        />
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </Stack>
  );
}
